import React from 'react';

export default function EmptyState({ title = 'Nothing here yet', subtitle = 'Try adjusting filters or come back later.', action = null, icon = '🍽️' }) {
    return (
        <div className="text-center py-16 px-4">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-3xl bg-gradient-to-br from-orange-100 to-orange-200 shadow-xl text-5xl mb-6 border-4 border-white">
                {icon}
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">{title}</h3>
            <p className="text-slate-600 mb-8 text-base max-w-md mx-auto leading-relaxed">{subtitle}</p>
            {action && (
                <div className="flex justify-center">
                    {action}
                </div>
            )}
        </div>
    );
}


